import EllipsisTextTooltip from 'components/EllipsisTextTooltip';
import { getIrelandTaxCodeLabel } from 'store/invoice-config/types';
import { ChargeOptionRow, Code, Desc, Nominal, Tax } from '../styles';

type Props = {
    charge: {
        productCode: string;
        description: string;
        nominalCode: string;
        taxCode: string;
    };
};

const AdditionalChargeOptionLabel = ({ charge }: Props) => {
    return (
        <ChargeOptionRow>
            <EllipsisTextTooltip tooltipTitle={charge.productCode}>
                <Code>{charge.productCode}</Code>
            </EllipsisTextTooltip>
            <EllipsisTextTooltip tooltipTitle={charge.description}>
                <Desc>{charge.description}</Desc>
            </EllipsisTextTooltip>
            <EllipsisTextTooltip tooltipTitle={charge.nominalCode}>
                <Nominal>{charge.nominalCode}</Nominal>
            </EllipsisTextTooltip>
            <EllipsisTextTooltip tooltipTitle={getIrelandTaxCodeLabel(charge.taxCode)}>
                <Tax>{getIrelandTaxCodeLabel(charge.taxCode)}</Tax>
            </EllipsisTextTooltip>
        </ChargeOptionRow>
    );
};

export default AdditionalChargeOptionLabel;
